/**
 * A collection of all meta tag identifiers used by modules in this library.
 */

/**
 * URL for the API to which we send performance events.
 * @type {String}
 */
export const PERFORMANCE_API_ENDPOINT = 'browser_performance_api_v1';

/**
 * URL for the API to which we send stats events.
 * @type {String}
 */
export const RELAY_API_ENDPOINT = 'browser_stats_api_v1';

/**
 * URL for the API to which we send browser errors.
 * @type {String}
 */
export const ERROR_API_ENDPOINT = 'browser_errors_api_v1';

/**
 * Base URL for the relay service.
 * @type {String}
 */
export const RELAY_API_BASE = 'browser_relay_service_api';

/**
 * Unique pop+request combined ID from DNS (Cloudflare).
 * @type {String}
 * @see https://support.cloudflare.com/hc/en-us/articles/203118044-What-is-the-CF-RAY-header-#h_f7a7396f-ec41-4c52-abf5-a110cadaca7c
 */
export const CF_RAY = 'cf:ray';

/**
 * Unique request ID from DNS (Cloudflare).
 * @type {String}
 */
export const CF_REQUEST_ID = 'cf:request_id';

/**
 * Unique identifier of the request serving this page.
 * @type {String}
 */
export const CTX_ID = 'ctx_id';

/**
 * Unique, persistent identifier of the website visitor.
 * @type {String}
 */
export const U_GUID = 'u_guid';

/**
 * Mark whether we identified this request as a crawler.
 * @type {String}
 */
export const KNOWN_CRAWLER = 'fiverrmeta:is_known_crawler';

/**
 * The current session's locale.
 * @type {String}
 */
export const LOCALE = 'fiverrmeta:locale';

/**
 * Session locale
 * @type {String}
 */
export const CURRENCY = 'fiverrmeta:currency';

/**
 * Whether this browser was detected as supporting ES6.
 * @type {String}
 */
export const ES6_BROWSER = 'es6_browser';

/**
 * Epoch time when the page was created on the server.
 * @type {String}
 */
export const CREATION_TIME = 'fiverrmeta:creation';

/**
 * Subsystem for logs.
 * @type {String}
 */
export const FACILITY = 'fiverrmeta:facility';

/**
 * The page's name.
 * @type {String}
 */
export const PAGENAME = 'fiverrmeta:pagename';

/**
 * Page name for BI performance reports.
 * @type {String}
 */
export const MONITOR_PAGENAME = 'fiverrmeta:performance_monitor_pagename';

/**
 * Logged in user ID, where applicable.
 * @type {String}
 */
export const USER_ID = 'user_id';
